export default __webpack_public_path__ + "static/media/17_gallery.fdb25a6b.jpg";